module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_blank-ff3e462161f4f35b43e0a25ffbf2defb.svg";